package com.milta.core.localization.translations.it

import com.milta.core.localization.OptimizationQuotaStrings

internal val OptimizationQuota = OptimizationQuotaStrings(
    exhaustedTitle = "Quota di ottimizzazioni raggiunta",
    exhaustedCreateRouteMessage = "Di nuovo disponibile il {date}. Puoi creare il giro senza ottimizzazione: l'ordine inserito viene mantenuto.",
    exhaustedCreateBatchMessage = "Di nuovo {limit} ottimizzazioni il {date}. Il lotto può essere creato senza ottimizzazione: l'ordine inserito viene mantenuto.",
    quotaReachedResetOn = "Quota di ottimizzazioni raggiunta — azzeramento il {date}",
    routeCreatedInEnteredOrder = "Giro creato nell'ordine inserito.",
    routeWillBeCreatedInEnteredOrder = "Il giro sarà creato nell'ordine inserito.",
    batchCreatedInEnteredOrder = "Il lotto è stato creato senza ottimizzazione, nell'ordine inserito.",
    sendWithoutOptimization = "Invia senza ottimizzazione",
    batchNotOptimizedTitle = "Lotto creato senza ottimizzazione",
    batchNotOptimizedMessage = "Quota di ottimizzazioni raggiunta. L'ordine attuale delle fermate viene mantenuto.",
    batchNotOptimizedMobileMessage = "Lotto creato senza ottimizzazione: quota di ottimizzazioni raggiunta. Ordine inserito mantenuto, fermate ripartite equamente.",
    reoptimizeAction = "Ri-ottimizza",
    reoptimizeUnavailableWeb = "Ri-ottimizzazione non disponibile: quota raggiunta, di nuovo il {date}. L'ordine attuale viene mantenuto e l'invio resta possibile.",
    reoptimizeUnavailableMobile = "Ri-ottimizzazione non disponibile fino al {date} (quota raggiunta). L'invio resta possibile.",
    stopAddedAtEndTitle = "Fermata aggiunta alla fine del giro",
    stopAddedAtEndMessage = "Quota di ottimizzazioni raggiunta — azzeramento il {date}. L'ordine delle altre fermate non cambia.",
    reoptimizeExhaustedHint = "Quota di ottimizzazioni raggiunta, di nuovo il {date}",
    myOptimizationsTitle = "Le mie ottimizzazioni",
    remainingForPeriod = "Rimanenti nel periodo",
    remainingSuffix = "rimaste",
    resetLabel = "Azzeramento",
    resetAtRenewal = "Al rinnovo dell'abbonamento",
    driverExplanation = "Si azzera al rinnovo del tuo abbonamento. Autista di un'Azienda: il tuo contatore segue l'abbonamento dell'Azienda, con il limite di prova finché è in prova.",
    enterpriseExplanation = "Si azzera al rinnovo del tuo abbonamento. Questo contatore riguarda solo le tue ottimizzazioni; ogni autista ha il suo.",
    webCounterNotice = "Questo contatore riguarda solo le ottimizzazioni avviate da questo account. Ogni autista ha il suo, visibile nella sua app.",
    historyTitle = "Cronologia",
    columnDate = "Data",
    columnAction = "Azione",
    columnTarget = "Giro interessato",
    columnOutcome = "Risultato",
    actionOptimizeRoute = "Ottimizzare un giro",
    actionCreateRouteBatch = "Creare un lotto",
    actionReoptimizeRouteBatch = "Ri-ottimizzare un lotto",
    actionReoptimizeOnStopAdded = "Ri-ottimizzare all'aggiunta di una fermata",
    actionReoptimizeInPlace = "Ri-ottimizzare sul posto",
    actionCreateOwnRoute = "Creare il mio giro",
    outcomeCounted = "Conteggiata",
    outcomeRefunded = "Restituita",
    outcomeRefundedLong = "Restituita — errore RoutaR",
    refundedNotCounted = "errore RoutaR, non conteggiata",
    targetRoute = "Giro del {date}",
    targetBatch = "Lotto del {date}",
    historyLoadingMore = "Caricamento delle righe successive…",
    historyEnd = "Fine della cronologia — {count} righe",
    historyEmpty = "Nessuna ottimizzazione in questo periodo.",
    historyLoadError = "Impossibile caricare la cronologia.",
    retryAction = "Riprova",
    loading = "Caricamento…",
    errorNoConnection = "Impossibile contattare il server — verifica la connessione.",
    errorGeneric = "Si è verificato un errore. Riprova più tardi.",
    tabOptimizations = "Ottimizzazioni RoutaR",
    tabAiTokens = "Token IA",
    comingSoon = "In arrivo",
    limitsDescription = "Numero di ottimizzazioni RoutaR consentite per account e per periodo di abbonamento, secondo il tipo di account e lo stato dell'abbonamento. Il contatore di ogni account si azzera al rinnovo del suo abbonamento.",
    columnTrial = "Prova",
    columnPaid = "A pagamento",
    rowEnterprise = "Account Azienda",
    rowDriver = "Autista",
    fieldRequired = "Campo obbligatorio.",
    fieldMustBePositive = "Deve essere maggiore di 0.",
    limitsFootnote = "Valori espressi in ottimizzazioni per periodo. Un autista di un'Azienda riceve il limite «Autista», di prova finché la sua Azienda è in prova, altrimenti a pagamento.",
    limitsSaved = "Limiti salvati. Azienda: {enterpriseTrial} prova · {enterprisePaid} a pagamento. Autista: {driverTrial} prova · {driverPaid} a pagamento.",
    limitsRejected = "Valori rifiutati: ogni limite deve essere maggiore di 0.",
    saveAction = "Salva",
    detailsAction = "Dettagli",
    accountDetailsTitle = "Dettagli dell'utente",
    sectionIdentity = "Identità",
    accountTypeLabel = "Tipo di account",
    kindEnterpriseOwner = "Account Azienda",
    kindEnterpriseDriver = "Autista di un'Azienda",
    kindIndependentDriver = "Autista indipendente",
    withoutOrganisation = "Senza organizzazione",
    subscriptionLabel = "Abbonamento",
    viaOrganisation = "Tramite organizzazione",
    subscriptionTrial = "Prova",
    subscriptionPaid = "A pagamento",
    appliedLimitLabel = "Limite applicato",
    limitKindEnterprise = "Limite Account Azienda",
    limitKindDriver = "Limite Autista",
    enterpriseInTrialSuffix = "(l'Azienda è in prova)",
    resetSourceOwn = "Rinnovo dell'abbonamento",
    resetSourceEnterprise = "Rinnovo di {enterprise}",
    exhaustedBadge = "Quota esaurita",
    manuallyAdjustedBadge = "Sostituito manualmente",
    replaceLabel = "Sostituisci il numero rimanente",
    replaceAction = "Sostituisci",
    replaceHelp = "Solo per il periodo in corso. All'azzeramento, l'account riparte dal limite globale.",
    replaceHelpEnterpriseDriver = "Modifica solo il contatore di {name}. Quello dell'Azienda e degli altri autisti non cambia.",
    replaceInvalid = "Inserisci un numero maggiore o uguale a 0.",
    replaceRejected = "Valore rifiutato dal server.",
    replaceMaximum = "Massimo 100.000.",
    replacedBanner = "Numero rimanente sostituito: {from} → {to}. Per il periodo in corso. Il {date}, ritorno al limite globale ({limit}).",
    adminHistoryTitle = "Cronologia delle ottimizzazioni",
    accountNotFound = "Account non trovato.",
)
